/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_Bookings_KeptInputs */

const fr_membership_plan_change_bookings_kept = /** @type {(inputs: Membership_Plan_Change_Bookings_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos réservations déjà posées sont conservées.`)
};

/**

* @param {Membership_Plan_Change_Bookings_KeptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_bookings_kept = /** @type {((inputs?: Membership_Plan_Change_Bookings_KeptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Bookings_KeptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_bookings_kept(inputs)
});